import { defineMessages } from 'react-intl';

export const ar = defineMessages({
  learnPageBreadcrumb: {
    id: 'seo_learn_page_breadcrumb_ar',
  },
});

export const da = defineMessages({
  learnPageBreadcrumb: {
    id: 'seo_learn_page_breadcrumb_da',
  },
});

export const de = defineMessages({
  learnPageBreadcrumb: {
    id: 'seo_learn_page_breadcrumb_de',
  },
});

export const el = defineMessages({
  learnPageBreadcrumb: {
    id: 'seo_learn_page_breadcrumb_el',
  },
});

export const en = defineMessages({
  learnPageBreadcrumb: {
    id: 'seo_learn_page_breadcrumb_en',
  },
});

export const en_us = defineMessages({
  learnPageBreadcrumb: {
    id: 'seo_learn_page_breadcrumb_en',
  },
});

export const es = defineMessages({
  learnPageBreadcrumb: {
    id: 'seo_learn_page_breadcrumb_es',
  },
});

export const fa = defineMessages({
  learnPageBreadcrumb: {
    id: 'seo_learn_page_breadcrumb_fa',
  },
});

export const fr = defineMessages({
  learnPageBreadcrumb: {
    id: 'seo_learn_page_breadcrumb_fr',
  },
});

export const he = defineMessages({
  learnPageBreadcrumb: {
    id: 'seo_learn_page_breadcrumb_he',
  },
});

export const hi = defineMessages({
  learnPageBreadcrumb: {
    id: 'seo_learn_page_breadcrumb_hi',
  },
});

export const id = defineMessages({
  learnPageBreadcrumb: {
    id: 'seo_learn_page_breadcrumb_id',
  },
});

export const is = defineMessages({
  learnPageBreadcrumb: {
    id: 'seo_learn_page_breadcrumb_is',
  },
});

export const it = defineMessages({
  learnPageBreadcrumb: {
    id: 'seo_learn_page_breadcrumb_it',
  },
});

export const jp = defineMessages({
  learnPageBreadcrumb: {
    id: 'seo_learn_page_breadcrumb_jp_full',
  },
});

export const ko = defineMessages({
  learnPageBreadcrumb: {
    id: 'seo_learn_page_breadcrumb_ko',
  },
});

export const mn = defineMessages({
  learnPageBreadcrumb: {
    id: 'seo_learn_page_breadcrumb_mn',
  },
});

export const nl = defineMessages({
  learnPageBreadcrumb: {
    id: 'seo_learn_page_breadcrumb_nl',
  },
});

export const no = defineMessages({
  learnPageBreadcrumb: {
    id: 'seo_learn_page_breadcrumb_no',
  },
});

export const pl = defineMessages({
  learnPageBreadcrumb: {
    id: 'seo_learn_page_breadcrumb_pl',
  },
});

export const pt = defineMessages({
  learnPageBreadcrumb: {
    id: 'seo_learn_page_breadcrumb_pt',
  },
});

export const ru = defineMessages({
  learnPageBreadcrumb: {
    id: 'seo_learn_page_breadcrumb_ru',
  },
});

export const sl = defineMessages({
  learnPageBreadcrumb: {
    id: 'seo_learn_page_breadcrumb_sl',
  },
});

export const sv = defineMessages({
  learnPageBreadcrumb: {
    id: 'seo_learn_page_breadcrumb_sv',
  },
});

export const sw = defineMessages({
  learnPageBreadcrumb: {
    id: 'seo_learn_page_breadcrumb_sw',
  },
});

export const th = defineMessages({
  learnPageBreadcrumb: {
    id: 'seo_learn_page_breadcrumb_th',
  },
});

export const tr = defineMessages({
  learnPageBreadcrumb: {
    id: 'seo_learn_page_breadcrumb_tr',
  },
});

export const uk = defineMessages({
  learnPageBreadcrumb: {
    id: 'seo_learn_page_breadcrumb_uk',
  },
});

export const yo = defineMessages({
  learnPageBreadcrumb: {
    id: 'seo_learn_page_breadcrumb_yo',
  },
});

export const zh = defineMessages({
  learnPageBreadcrumb: {
    id: 'seo_learn_page_breadcrumb_zh_cn',
  },
});
